import React from 'react';
import "../index.css";
import { Link } from "react-router-dom";

const menuItems = [
    { to: "/gallery", label: "Galerie", icon: "bi-images" },
    { to: "/videos", label: "Videa", icon: "bi-play-circle" },
    { to: "/knives", label: "Volné nože", icon: "bi-hammer" },
    { to: "/contact", label: "Kontakt", icon: "bi-envelope" },
];

const Home = () => {
    return (
        <div className="position-absolute top-50 start-50 translate-middle hk-home-menu text-center">
            {menuItems.map((item) => (
                <div className="fs-1 my-3" key={item.to}>
                    <Link to={item.to} className="hk-home-link">
                        <i className={`bi ${item.icon} hk-home-link-icon`}></i>
                        {item.label}
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default Home;
